import React from "react";
import PropTypes from "prop-types";
// mdb Shim Imports
import Button from "../../Component/MDBShim/Button";
import Card from "../../Component/MDBShim/Card";
import CardBody from "../../Component/MDBShim/CardBody";
import Container from "../../Component/MDBShim/Container";
import Spinner from "../../Component/MDBShim/Spinner";
import Input from "../../Component/MDBShim/Input";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import CardHeader from "../../Component/MDBShim/CardHeader";
import Modal from "../../Component/MDBShim/Modal";
import ModalBody from "../../Component/MDBShim/ModalBody";
import ModalHeader from "../../Component/MDBShim/ModalHeader";
import ModalFooter from "../../Component/MDBShim/ModalFooter";
import MDBTable from "../../Component/MDBShim/MDBTable";
import MDBTableBody from "../../Component/MDBShim/MDBTableBody";
import MDBTableHead from "../../Component/MDBShim/MDBTableHead";
import MDBCol from "../../Component/MDBShim/MDBCol";
import MDBRow from "../../Component/MDBShim/MDBRow";
import MDBCard from "../../Component/MDBShim/MDBCard";

import AddProdcutMatrixEntry from "./addProdcutMatrixEntry";
import ReactTooltip from "react-tooltip";
import Select from "react-select";
import EquipmentTrainingLinkService from "./EquipmentTrainingLinkService";
import TrainingLinkService from "./trainingLinkService";
import ProductSubTypeService from "../Security/ProductService/productSubTypeService";
import prodcutMatrixEntryService from "../Security/ProdcutMatrixEntryService/prodcutMatrixEntryService";
import LayerLegacy from "../../LayerLegacy";
import Security from "../../Utility/Security";
import MainContext from "../../Context/MainContext/MainContext";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIArrowBackIcon from "@mui/icons-material/ArrowBack";
import MUICloseIcon from "@mui/icons-material/Close";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUIOpenInNewIcon from "@mui/icons-material/OpenInNew";
import MUISaveIcon from "@mui/icons-material/Save";

const fixedLightMaterialUITheme = createTheme({
  palette: { mode: "light" },
});

export default class editProductSubType extends LayerLegacy {
  constructor(props) {
    super(props);

    const data = {
      columns: [
        {
          label: "ID",
          field: "id",
          sort: "asc",
          width: 100,
        },
        {
          label: "Name",
          field: "name",
          sort: "asc",
          width: 200,
        },
        {
          label: "HCPCS",
          field: "hcpcs",
          sort: "asc",
          width: 100,
        },
        {
          label: "Item ID",
          field: "itemid",
          sort: "asc",
          width: 100,
        },
        {
          label: "Max Billable Units",
          field: "laborUnits",
          sort: "asc",
          width: 70,
        },
        {
          label: "Default Quantity",
          field: "defaultQuantity",
          sort: "asc",
          width: 70,
        },
        {
          label: "Vendor",
          field: "vendor",
          sort: "asc",
          width: 100,
        },
        {
          label: "Override Points",
          field: "overridepoints",
          sort: "asc",
          width: 100,
        },
        {
          label: "Edit",
          field: "button",
          sort: "asc",
          width: 100,
        },
      ],
      rows: [],
    };

    let productType = props.location.state.productType || {},
      id = props.match.params.id;

    if (id) {
      this.retrieveProducts(id);
    }

    this.state = {
      id: id,
      data: data,
      isLoaded: false,
      updatedProduct: {},
      productType: productType,
      modal: false,
      toggleWarning: false,
      errorMessage: "",
      currIndex: -1,
      allVendors: [],
      vendorOptions: [],
      maxBillableLaborUnitsOptions: [
        { label: "0 Labor Units", value: 0 },
        { label: "1 Labor Units", value: 1 },
        { label: "2 Labor Units", value: 2 },
        { label: "3 Labor Units", value: 3 },
        { label: "4 Labor Units", value: 4 },
      ],
      currentEquipmentVideos: [],
      videosLoaded: false,
      selectedVendor: null,
      selectedLaborUnits: null,
      overrideModal: false,
      allVideos: [],
      vidsList: [],
      fullVideosLoaded: false,
      chosenVideo: {},
      insuranceOptions: [],
      insuranceTypes: [],
      selectedInsurance: null,
      editPointsId: null,
      productMatrixEntrySubTypes: [],
      nProduct: {},
    };

    this.getAllVideos();
  }

  static contextType = MainContext; // For legacy class components

  componentDidMount() {
    this.getVendorsOptions();
    this.getInsuranceOptions();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { allVendors, insuranceTypes } = this.context;
    if (
      allVendors.length > 0 &&
      allVendors.length !== prevState.allVendors.length
    ) {
      this.getVendorsOptions();
    }
    if (
      insuranceTypes.length > 0 &&
      insuranceTypes.length !== prevState.insuranceTypes.length
    ) {
      this.getInsuranceOptions();
    }
  }

  getInsuranceOptions() {
    const { insuranceTypes } = this.context;
    let arr = [];
    insuranceTypes.map((v) => {
      return arr.push({
        label: v.name,
        value: v.id,
      });
    });
    this.setState({
      insuranceTypes: insuranceTypes,
      insuranceOptions: arr,
    });
  }

  getVendorsOptions() {
    const { allVendors } = this.context;
    let arr = [];
    allVendors.map((v) => {
      return arr.push({
        label: v.name,
        value: v.id,
        val: { id: v.id, name: v.name },
      });
    });
    this.setState({
      allVendors: allVendors,
      vendorOptions: arr,
    });
  }

  getVendor(product) {
    return (
      product.vendor ||
      (product.vendorId != null
        ? this.context.vendorsIndexed[product.vendorId]
        : null)
    );
  }

  getAllProductMatrixEntrySubTypes(id) {
    prodcutMatrixEntryService
      .getProductMatrixEntryBySubType(id)
      .then((entries) => {
        // console.log(entries)
        this.setState({
          productMatrixEntrySubTypes: entries,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  createProductMatrixEntry(p) {
    prodcutMatrixEntryService
      .createProduct(p)
      .then((res) => {
        // console.log(res)
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar("An error occured adding a new product", {
          variant: "warning",
        });
      });
  }

  renderCardHeader() {
    return (
      <CardHeader style={{ textAlign: "center", backgroundColor: "#5881C1" }}>
        <Button
          style={{ float: "left" }}
          floating
          size="sm"
          color={"warning"}
          data-tip={"Go Back"}
          onClick={() => this.props.history.push("/products")}
        >
          <MUIArrowBackIcon style={{ fontSize: "2em" }} />
        </Button>

        {this.state.productType ? this.state.productType.name : " Products"}

        <Button
          style={{
            float: "right",
            // Disabling the button also removes the tooltip so adding this rig
            cursor: !Security.hasPermission("productSubType.manage")
              ? "default"
              : "pointer",
            opacity: !Security.hasPermission("productSubType.manage") ? 0.5 : 1,
          }}
          floating
          size="sm"
          color={"secondary"}
          data-tip={
            Security.hasPermission("productSubType.manage")
              ? "Add New Product"
              : "Must be Admin"
          }
          onClick={
            Security.hasPermission("productSubType.manage")
              ? this.addButtonClick.bind(this)
              : (e) => e.preventDefault()
          }
        >
          <MUIAddIcon style={{ fontSize: "2em" }} />
        </Button>

        <Button
          style={{ float: "right" }}
          floating
          size="sm"
          color={"secondary"}
          data-tip={"View Point Overrides"}
          onClick={() =>
            this.props.history.push({
              pathname: "/productMatrixEntry",
              state: {
                id: this.state.productType.id,
                product: this.state.productType,
              },
            })
          }
        >
          <MUIOpenInNewIcon />
        </Button>
      </CardHeader>
    );
  }

  retrieveProducts(id) {
    let t = this;

    return ProductSubTypeService.getOneProductSubType(id)
      .then((res) => {
        let arr = [],
          data = this.state.data;
        res.forEach((element, index) => {
          const vendor = this.getVendor(element);
          arr.push({
            id: element.id,
            name: element.name,
            hcpcs: element.hcpcs,
            itemid: element.itemId || "",
            laborUnits: element.maxBillableLaborUnits,
            defaultQuantity: element.defaultQuantity,
            vendor: vendor ? vendor.name : "",
            overridepoints: element.overridePoints ? "true" : "",
            edit: t.editButton(element, index),
          });
        });
        data.rows = arr;
        this.setState({
          data: data,
          isLoaded: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getAllVideos() {
    TrainingLinkService.getAllTrainingLinks().then((r) => {
      let obj = [];

      r.forEach((v) => {
        obj.push({ text: v.name + ":   " + v.description, value: v });
      });

      this.setState({
        allVideos: r,
        vidsList: obj,
        fullVideosLoaded: true,
      });
    });
  }

  getProductVideos(id) {
    EquipmentTrainingLinkService.getVideosByCategory(id).then((r) => {
      this.setState({
        currentEquipmentVideos: r,
        videosLoaded: true,
      });
    });
  }

  addVideo() {
    let video = this.state.chosenVideo,
      prod = this.state.updatedProduct,
      v = this.state.currentEquipmentVideos;

    if (!video.id) {
      return;
    }

    if (
      v.findIndex((vals) => {
        return vals.trainingLinkId === video.id;
      }) > -1
    ) {
      NotistackEnqueueSnackbar("Video already exists for this product.", {
        variant: "warning",
      });
      return;
    }

    this.setState({
      videosLoaded: false,
    });

    let vo = {
      name: video.name,
      productSubTypeId: prod.id,
      trainingLinkId: video.id,
      productCategoryId: -1,
    };

    EquipmentTrainingLinkService.createTrainingLink(vo)
      .then((r) => {
        this.setState({
          // currentEquipmentVideos: v,
          chosenVideo: {},
        });
        this.getProductVideos(this.state.updatedProduct.id);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally((a) => {
        this.setState({
          videosLoaded: true,
        });
      });
  }

  editButton(product, index) {
    return (
      <MUIEditIcon
        style={{ color: "green" }}
        onClick={() => {
          this.editButtonClick(product, index);
        }}
      />
    );
  }

  renderRemoveButton(id) {
    return (
      <MUIDeleteIcon
        style={{ color: "red" }}
        onClick={() => this.handleRemoveClick(id)}
      />
    );
  }

  editButtonClick(product, index) {
    let p = JSON.parse(JSON.stringify(product));
    this.setState({
      updatedProduct: p,
      currIndex: index,
    });
    this.toggleEdit();
    this.getProductVideos(product.id);
    this.getAllProductMatrixEntrySubTypes(product.id);
  }

  toggleEdit = () => {
    this.setState({
      modal: !this.state.modal,
      currentEquipmentVideos: [],
      videosLoaded: false,
      errorMessage: "",
      selectedVendor: null,
      selectedLaborUnits: null,
      chosenVideo: {},
    });
  };

  toggleWarningModal = () => {
    this.setState({
      toggleWarning: !this.state.toggleWarning,
      modal: !this.state.modal,
    });
  };

  handlePointsChange = (i, e) => {
    let prod = this.state.productMatrixEntrySubTypes;

    if (
      prod &&
      prod.length > 0 &&
      prod.filter((x) => x.insuranceTypeId === i.id).length > 0
    ) {
      prod.forEach((it) => {
        if (it.insuranceTypeId === i.id) {
          it.points = e.target.value ? parseFloat(e.target.value) : null;
        }
      });
    } else {
      prod.push({
        deleted: false,
        points: e.target.value ? parseFloat(e.target.value) : null,
        insuranceTypeId: i.id,
        productSubTypeId: this.state.updatedProduct.id,
      });
    }

    this.setState({
      productMatrixEntrySubTypes: prod,
    });
  };

  updateProductMatrixEntries(prod) {
    prodcutMatrixEntryService
      .editProduct(prod)
      .then((res) => {
        // console.log(res)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  removePoints(id) {
    prodcutMatrixEntryService
      .deleteProduct(id)
      .then((res) => {
        // console.log(id,res)
      })
      .catch((err) => {
        console.log(err);
        NotistackEnqueueSnackbar(
          "There was an issue removing override points.",
          {
            variant: "error",
          },
        );
      });
  }

  savePointsChange(item) {
    if (!item.id) {
      this.createProductMatrixEntry(item);
    } else {
      this.updateProductMatrixEntries(item);
    }
  }

  renderWarning() {
    return (
      <Container>
        <Modal
          size={"med"}
          isOpen={this.state.toggleWarning}
          toggle={this.toggleWarningModal}
        >
          <ModalHeader style={{ backgroundColor: "#F93154", color: "white" }}>
            Warning
          </ModalHeader>
          <ModalBody style={{ backgroundColor: "white" }}>
            <Container>
              <MDBRow>
                <p>
                  All override points will be deleted. Are you sure you want to
                  continue?
                </p>
              </MDBRow>
            </Container>
          </ModalBody>
          <ModalFooter style={{ backgroundColor: "white" }}>
            <Button
              size={"sm"}
              data-tip={"Cancel"}
              color="red"
              onClick={this.toggleWarningModal}
            >
              <MUICloseIcon style={{ fontSize: "2em" }} />
            </Button>
            <Button
              size={"sm"}
              data-tip={"Save"}
              onClick={this.editSaveButtonClick}
              color="success"
            >
              <MUISaveIcon style={{ fontSize: "2em" }} />
            </Button>
          </ModalFooter>
          <ReactTooltip />
        </Modal>
      </Container>
    );
  }

  renderModal() {
    if (this.state.currIndex > -1) {
      let st = this.state,
        up = st.updatedProduct,
        entries = [],
        insurance = st.insuranceTypes;

      if (
        st.productMatrixEntrySubTypes !== null &&
        st.productMatrixEntrySubTypes.length > 0
      ) {
        entries = this.state.productMatrixEntrySubTypes.filter(
          (e) => e.productSubTypeId === up.id,
        );
      }

      return (
        <Container>
          <Modal size={"lg"} isOpen={this.state.modal} toggle={this.toggleEdit}>
            <ModalHeader style={{ backgroundColor: "white" }}>
              Edit Product
            </ModalHeader>
            <ModalBody style={{ backgroundColor: "white" }}>
              <Container>
                <MDBRow>
                  <MDBCol size="12">
                    <p style={{ color: "red" }}>{this.state.errorMessage}</p>
                  </MDBCol>
                  <MDBCol size="12">
                    <Input
                      containerClass={"smallMargin"}
                      outline
                      value={up.name || ""}
                      onChange={this.handleChange.bind(this, "name")}
                      label="Name"
                      size="sm"
                      sx={{ marginBottom: 1 }}
                    />
                  </MDBCol>
                  <MDBCol size="6">
                    <Input
                      containerClass={"smallMargin"}
                      outline
                      value={up.hcpcs || ""}
                      onChange={this.handleChange.bind(this, "hcpcs")}
                      label="HCPCS"
                      size="sm"
                    />
                  </MDBCol>
                  <MDBCol size="6">
                    <Input
                      containerClass={"smallMargin"}
                      outline
                      value={up.itemId || ""}
                      onChange={this.handleChange.bind(this, "itemId")}
                      label="Item Id"
                      size="sm"
                      sx={{ marginBottom: 1 }}
                    />
                  </MDBCol>
                  <MDBCol size="6">
                    <Input
                      containerClass={"smallMargin"}
                      outline
                      value={up.defaultQuantity ?? ""}
                      onChange={this.handleChange.bind(this, "defaultQuantity")}
                      label="Default Quantity"
                      type="number"
                      min="0"
                      size="sm"
                      sx={{ marginBottom: 1.5 }}
                    />
                  </MDBCol>
                  <MDBCol size="5" style={{ zIndex: "99" }}>
                    <Select
                      placeholder={this.getVendor(up)?.name || "Select Vendor"}
                      options={st.vendorOptions}
                      onChange={this.handleVendorChange.bind(this)}
                      value={st.selectedVendor}
                    />
                  </MDBCol>
                  <MDBCol
                    size="3"
                    style={{ zIndex: "99", marginRight: "16px" }}
                  >
                    <Select
                      placeholder={
                        up.maxBillableLaborUnits
                          ? up.maxBillableLaborUnits
                          : "Labor Units"
                      }
                      options={st.maxBillableLaborUnitsOptions}
                      onChange={this.handleLaborChange.bind(this)}
                      value={st.selectedLaborUnits}
                    />
                  </MDBCol>
                  <MDBCol size="4" style={{ paddingTop: 8 }}>
                    <Input
                      value={up.overridePoints}
                      id="overridepnts"
                      checked={up.overridePoints}
                      type={"checkbox"}
                      onChange={this.handleChange.bind(this, "overridePoints")}
                      label="Override Points"
                      size="sm"
                      sx={{ marginBottom: 1 }}
                    />
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  {insurance.map((i, index) => {
                    return (
                      <MDBCol size="4" style={{ marginTop: "20px" }}>
                        <Input
                          key={index}
                          type="number"
                          disabled={!up.overridePoints ? true : false}
                          label={i.name}
                          value={
                            entries && entries.length > 0
                              ? entries
                                  .filter((e) => e.insuranceTypeId === i.id)
                                  .map((x) => x.points)
                              : null
                          }
                          onChange={this.handlePointsChange.bind(this, i)}
                          sx={{ marginBottom: 1 }}
                        />
                      </MDBCol>
                    );
                  })}
                </MDBRow>
              </Container>
            </ModalBody>
            <ModalFooter style={{ backgroundColor: "white" }}>
              <Button
                size={"sm"}
                data-tip={"Close"}
                color="red"
                onClick={this.toggleEdit}
              >
                <MUICloseIcon style={{ fontSize: "2em" }} />
              </Button>
              <Button
                size={"sm"}
                data-tip={"Save"}
                onClick={
                  entries !== null &&
                  entries.length > 0 &&
                  up.overridePoints === false
                    ? this.toggleWarningModal
                    : this.editSaveButtonClick
                }
                color="success"
              >
                <MUISaveIcon style={{ fontSize: "2em" }} />
              </Button>
            </ModalFooter>
            <ReactTooltip />
          </Modal>
        </Container>
      );
    }
  }

  removeVideoFromEquipment(v, idx) {
    this.setState({
      videosLoaded: false,
    });

    EquipmentTrainingLinkService.deleteTrainingLink(v.id)
      .then((r) => {
        this.getProductVideos(this.state.updatedProduct.id);
      })
      .catch((e) => {
        NotistackEnqueueSnackbar("There was an error.  Try again later.", {
          variant: "warning",
        });
      })
      .finally((a) => {
        this.setState({
          videosLoaded: true,
        });
      });
  }

  renderProductVideos() {
    let t = this;
    let video = t.state.chosenVideo;

    function deleteButton(v, idx) {
      return (
        <MUIDeleteIcon
          style={{ color: "red" }}
          onClick={() => t.removeVideoFromEquipment(v, idx)}
        />
      );
    }

    if (!video && !this.state.videosLoaded) {
      return <Spinner small />;
    }
    return this.state.currentEquipmentVideos.map((v, idx) => {
      return (
        <MDBCol size="6">
          <MDBCard key={idx} style={{ margin: 6, padding: 4 }}>
            <MDBRow>
              <MDBCol size="9">{v.name}</MDBCol>

              <MDBCol size="3">{deleteButton(v, idx)}</MDBCol>
            </MDBRow>
          </MDBCard>
        </MDBCol>
      );
    });
  }

  handleOverrideClick = () => {
    this.setState((state) => ({
      productSubType: {
        name: state.updatedProduct.name,
        id: state.updatedProduct.id,
      },
    }));
    this.toggleEdit();
    this.toggleOverrideModal();
  };

  overrideModal() {
    let st = this.state,
      entries = st.productMatrixEntrySubTypes;

    return (
      <Modal
        isOpen={this.state.overrideModal}
        toggle={() => {
          return;
        }}
      >
        <AddProdcutMatrixEntry
          closeButton={this.toggleOverrideModal.bind(this)}
          productSubType={this.state.productSubType}
          getAllProductMatrixEntrySubTypes={() =>
            this.getAllProductMatrixEntrySubTypes()
          }
          entries={entries}
          editSaveButtonClick={() => this.editSaveButtonClick()}
        />
      </Modal>
    );
  }

  toggleOverrideModal = () => {
    this.setState({
      overrideModal: !this.state.overrideModal,
    });
  };

  handleVendorChange = (e) => {
    this.setState({
      selectedVendor: e,
    });
  };
  handleLaborChange = (e) => {
    this.setState({
      selectedLaborUnits: e,
    });
  };

  handleChange(property, e) {
    let up = this.state.updatedProduct;
    if (property === "overridePoints") {
      up[property] = !up[property];
    } else if (property === "defaultQuantity") {
      const parsed = parseInt(e.target.value, 10);
      up[property] =
        e.target.value === "" || Number.isNaN(parsed) || parsed === 0
          ? null
          : parsed;
    } else {
      up[property] = e.target.value;
    }
    this.setState({
      updatedProduct: up,
    });
  }

  addButtonClick() {
    return this.props.history.push({
      pathname: "/productType/new",
      state: { productType: this.state.productType, productId: this.state.id },
    });
  }

  validate() {
    let up = this.state.updatedProduct;
    if (up.name === "") {
      this.setError("Please enter Product Name");
      return false;
    } else if (up.hcpcs === "") {
      this.setError("Please enter HCPCS");
      return false;
    }
    return true;
  }

  setError(e) {
    this.setState({
      errorMessage: e,
    });
  }

  editSaveButtonClick = () => {
    if (this.validate()) {
      let t = this,
        st = t.state,
        currentProduct = st.updatedProduct,
        data = st.data,
        currentIndex = st.currIndex,
        selectedVendor = st.selectedVendor,
        selectedLaborHours = st.selectedLaborUnits,
        entries = st.productMatrixEntrySubTypes;

      if (selectedVendor) {
        currentProduct.vendor = selectedVendor.val;
        currentProduct.vendorId = selectedVendor.val.id;
      }
      if (selectedLaborHours) {
        currentProduct.maxBillableLaborUnits = selectedLaborHours.value;
      }

      return ProductSubTypeService.updateProductSubType(currentProduct)
        .then(() => {
          NotistackEnqueueSnackbar("Saved Successfully!", {
            variant: "success",
          });
          data.rows[currentIndex].id = currentProduct.id;
          data.rows[currentIndex].name = currentProduct.name;
          data.rows[currentIndex].hcpcs = currentProduct.hcpcs;
          data.rows[currentIndex].itemid = currentProduct.itemId || "";
          data.rows[currentIndex].laborUnits =
            currentProduct.maxBillableLaborUnits ?? null;
          data.rows[currentIndex].defaultQuantity =
            currentProduct.defaultQuantity ?? null;
          data.rows[currentIndex].vendor =
            this.getVendor(currentProduct)?.name || "";
          data.rows[currentIndex].overridepoints = currentProduct.overridePoints
            ? "true"
            : "";
          data.rows[currentIndex].edit = t.editButton(
            currentProduct,
            currentIndex,
          );
          if (
            currentProduct.overridePoints === false &&
            entries !== null &&
            entries.length > 0
          ) {
            entries.forEach((entry) => {
              if (entry.id) this.removePoints(entry.id);
            });
          } else if (entries !== null && entries.length > 0) {
            entries.forEach((entry) => this.savePointsChange(entry));

            this.getAllProductMatrixEntrySubTypes(currentProduct.id);
          }
          t.setState({
            data: data,
            modal: false,
            toggleWarning: false,
            errorMessage: "",
            productSubType: {
              name: currentProduct.name,
              id: currentProduct.id,
            },
            productMatrixEntrySubTypes: [],
          });
        })
        .catch((err) => {
          NotistackEnqueueSnackbar("An error occurred while saving.", {
            variant: "warning",
          });
        });
    }
  };

  renderTable() {
    if (this.state.isLoaded === true) {
      return (
        <MDBTable style={{ textAlign: "center" }}>
          <MDBTableHead columns={this.state.data.columns} />
          <MDBTableBody rows={this.state.data.rows} />
        </MDBTable>
      );
    } else {
      return <div></div>;
    }
  }

  renderLoadingSpinner() {
    return (
      <ThemeProvider theme={fixedLightMaterialUITheme}>
        <Container className="mt-5">
          <div style={{ textAlign: "center", verticalAlign: "center" }}>
            <Spinner multicolor />
          </div>
        </Container>
      </ThemeProvider>
    );
  }

  renderContent() {
    if (this.state.isLoaded === false) {
      return this.renderLoadingSpinner();
    }

    return (
      <ThemeProvider theme={fixedLightMaterialUITheme}>
        <div>
          <Container className="mt-5">
            <Card>
              {this.renderCardHeader()}
              <CardBody>{this.renderTable()}</CardBody>
              <ReactTooltip />
            </Card>
            {this.overrideModal()}
            {this.renderModal()}
            {this.renderWarning()}
          </Container>
        </div>
      </ThemeProvider>
    );
  }
}
